import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35469bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-mission" }
const _hoisted_2 = { class: "section-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, " 원더플 피플의 미션 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-desc" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 피플이 되어볼까요?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 45일 동안 제로 웨이스트 박스를 가득 채워주세요."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 페트병이 다시 투명 음료 페트병이 되는 "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 보틀투보틀의 마법을 경험하실 거예요. "),
  /*#__PURE__*/_createElementVNode("div", { class: "margin-t" }, " 자 원더플 피플, 챌린지를 선택해 볼까요? ")
], -1))
const _hoisted_5 = { class: "box-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 제로 웨이스트 박스는 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 75리터 종량제 쓰레기 봉투와 비슷한 크기예요. ")
], -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "section-2" }
const _hoisted_10 = ["media", "srcset"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "section-3" }

import Bg from './bg.vue';
import { type ComputedRef, ref, inject } from 'vue';
import SideBottle from './side-bottle.vue';
import RecycledBottleProductionProcessPopup from './popups/recycled-bottle-production-process.vue';
import Desc from './desc.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = inject<ComputedRef<Record<string, string>>>('images')!;

const popupVisible = ref(false);
function openPopup() {
  popupVisible.value = true;
}

const descs = [
`정해진 기간 내에 제로 웨이스트 박스 전부 수거 신청해야 <br class="d-block d-md-none">
리워드를 받을 수 있어요.`,
`올바른 분리배출 방법을 지키지 않거나 투명 음료 페트병이 <br class="d-block d-md-none">
아닌 품목을 보내면 리워드를 받을 수 없어요.`,
`투명 음료 페트병을 제로 웨이스트 박스의 표시선까지 <br class="d-block d-md-none">
채워야 미션 성공!`
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RecycledBottleProductionProcessPopup, {
      modelValue: popupVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupVisible).value = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _unref(images)['mission-bottle-box']
        }, null, 8, _hoisted_6),
        _hoisted_7
      ]),
      _createVNode(SideBottle),
      _createElementVNode("img", {
        class: "bottle-135deg-3-line",
        src: _unref(images)['bottle-135deg-3-line']
      }, null, 8, _hoisted_8)
    ]),
    _createVNode(Bg, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_9, [
          _createElementVNode("picture", null, [
            _createElementVNode("source", {
              media: `(max-width: ${768}px)`,
              srcset: _unref(images)['mission-desc']
            }, null, 8, _hoisted_10),
            _createElementVNode("img", {
              class: "mission-desc",
              src: _unref(images)['mission-desc-pc']
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("div", {
            class: "section-btn",
            onClick: openPopup
          }, " 재생 보틀은 어떻게 만들어지나요? ")
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_12, [
      _createVNode(Desc, {
        title: "잠깐!",
        value: descs
      })
    ])
  ]))
}
}

})